import { useEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Analytics } from '@vercel/analytics/react';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Hero from './sections/Hero';
import HowItWorks from './sections/HowItWorks';
import Security from './sections/Security';
import ForAgencies from './sections/ForAgencies';
import ForWorkers from './sections/ForWorkers';
import Pricing from './sections/Pricing';
import CTA from './sections/CTA';
import LiquidDivider from './components/LiquidDivider';

gsap.registerPlugin(ScrollTrigger);

export default function App() {
  useEffect(() => {
    const timeout = setTimeout(() => {
      ScrollTrigger.refresh();
    }, 200);

    return () => {
      clearTimeout(timeout);
      ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
    };
  }, []);

  return (
    <div className="relative min-h-screen bg-bg-primary text-white overflow-x-hidden">
      <Navbar />
      <main>
        <Hero />
        <LiquidDivider />
        <HowItWorks />
        <LiquidDivider />
        <Security />
        <LiquidDivider />
        <ForAgencies />
        <LiquidDivider />
        <ForWorkers />
        <LiquidDivider />
        <Pricing />
        <LiquidDivider />
        <CTA />
      </main>
      <Footer />
      <Analytics />
    </div>
  );
}
